export default function templates(state={}, action) {
    switch (action.type) {
    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./src/_app/quick_response/reducers/templates_reducers.js